export default __webpack_public_path__ + "static/media/pn.c35d8053.jpg";